module.exports = __webpack_public_path__ + "img/icon0.a013d778.png";